import React, { FunctionComponent } from 'react';
import { Text } from '@upstox/upstox-ui';
import { GTM_EVENTS } from 'src/constants';
import { registerGTMEvent } from 'utils/events';

type Props = {
  title?: string;
  baseUrl?: string;
};

const AlphabeticLinks: FunctionComponent<Props> = ({
  title,
  baseUrl,
}: {
  title: string;
  baseUrl: string;
}) => {
  return (
    <section>
      <div className="footer-alphabet-links">
        <span className="footer-alpha-list-title">
          <Text color="text.white">{title} </Text>
        </span>

        <ul className="footer-alpha-list footer-list-unstyled">
          {[
            ...new Array(26).fill(1).map((_, i) => String.fromCharCode(65 + i)),
            'Others',
          ].map((alpha) => (
            <li key={alpha} className="footer-alpha-list-items">
              <a
                href={baseUrl + alpha.toLowerCase() + '/'}
                onClick={() => {
                  registerGTMEvent({
                    event: GTM_EVENTS.FOOTER_INTERACTION,
                    cta_text: alpha,
                    header_text: title,
                    section_name: 'NA'
                  });
                }}
              >
                <Text color="text.white">{alpha}</Text>{' '}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default AlphabeticLinks;
